import AccountTotalsSummary from './AccountTotalsSummary';

export default AccountTotalsSummary;
